var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteColorCancelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2857 16.8357C21.2381 17.7882 21.2381 19.3328 20.2857 20.2853C19.8092 20.7618 19.1848 21 18.5604 21C17.936 21 17.3116 20.7618 16.8356 20.2853L10.5002 13.9498L4.16426 20.2853C3.6883 20.7618 3.0639 21 2.43949 21C1.81508 21 1.19068 20.7618 0.714719 20.2853C-0.23824 19.3328 -0.23824 17.7882 0.714719 16.8357L7.05065 10.5003L0.714719 4.16429C-0.23824 3.21185 -0.23824 1.66717 0.714719 0.714724C1.66716 -0.238241 3.21182 -0.238241 4.16426 0.714724L10.5002 7.05017L16.8356 0.714724C17.788 -0.238241 19.3327 -0.238241 20.2857 0.714724C21.2381 1.66717 21.2381 3.21185 20.2857 4.16429L13.9497 10.5003L20.2857 16.8357Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteColorCancelIcon);
export default __webpack_public_path__ + "static/media/white-color-cancel-icon.0692ab6971c31999895d6d8e0fa2d858.svg";
export { ForwardRef as ReactComponent };